import React from 'react';
import styled from 'styled-components';

const SpanDetailPriceBlock = styled.p`
    margin-bottom: 20px;
`;

const SpanDetailProdPriceBlock = styled.span`
    display: ${props => props.isSale ? 'block' : 'block'};
    font-size:  ${props => props.isSale ? '18px' : '24px'};
    font-weight: ${props => props.isSale ? '400' : '600'};
    color:  ${props => props.isSale ? '#999' : '#111'};
    text-decoration: ${props => props.isSale ? 'line-through' : ''};
    line-height: ${props => props.isSale ? '18px' : '28px'};
    margin-bottom: ${props => props.isSale ? '6px' : '0px'};
`;

const SpanDetailNumberBlock = styled.span`
    font-family: Montserrat,sans-serif;
`;

const SpanDetailPrice = ({ salePrice, prodPrice }) => {

    let isSale = (salePrice > 0 && salePrice !== prodPrice);

    const saleValue = isSale ?
        <SpanDetailProdPriceBlock isSale={isSale}>
            <SpanDetailNumberBlock>{Number(prodPrice.toFixed(1)).toLocaleString()}</SpanDetailNumberBlock>원
        </SpanDetailProdPriceBlock> : '';

    return (
        <SpanDetailPriceBlock>
            {saleValue}
            <SpanDetailProdPriceBlock isSale={false}>
                <SpanDetailNumberBlock>{Number(salePrice.toFixed(1)).toLocaleString()}</SpanDetailNumberBlock>원
            </SpanDetailProdPriceBlock>
        </SpanDetailPriceBlock>

    );
};

export default SpanDetailPrice;